import { render, staticRenderFns } from "./Imgcreateway.vue?vue&type=template&id=1e7c534e&scoped=true&"
import script from "./Imgcreateway.vue?vue&type=script&lang=ts&"
export * from "./Imgcreateway.vue?vue&type=script&lang=ts&"
import style0 from "./Imgcreateway.vue?vue&type=style&index=0&id=1e7c534e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7c534e",
  null
  
)

export default component.exports